import React  from 'react';
import Templates from './Templates';
import { images } from "../../helper";
import './style.css';

export const Modal = ({ name, title, size='default', isOpen, onClose,  ...rest }) => {
    const componentObject = Templates.filter((componentArray) => componentArray.name === name)[0];
    const handleClose = (event, data = true) => {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        };

        onClose(data);
    };

    const sizeList = `modal modal-${size}`

    return (
        <div
            className={'modal__background'}
            style={{'display': isOpen ? "flex" : "none"}}
        >
            <div className={'modal-dialog'}>
                <div
                    className={sizeList}
                    onClick={(event) => event.stopPropagation(event)}
                >
                    <div className="modal__header">
                        <h2 className="modal__title">
                            {title || componentObject.title}
                        </h2>
                        <button
                            type="button"
                            onClick={(event) => handleClose(event)}
                            className="modal__icon-button"
                        >
                            <img src={images.closer} alt="close" />
                        </button>
                    </div>
                    <div className="modal__content">
                        <componentObject.component handleClose={handleClose} {...rest}/>
                    </div>
                </div>
            </div>
        </div>
    );
};
